export default "__VITE_ASSET__B86zS8gi__"